import gql from 'graphql-tag'

const agenti = gql`
  query utenti (
    $limit: Int!,
    $offset: Int
  ) {
    utenti (
      limit: $limit,
      offset: $offset,
      where: { ruolo: AGENTE }
    ) {
      totalCount
      nodes {
        id
        nome
        email
        ruolo
      }
    }
  }
`

export default agenti


// WEBPACK FOOTER //
// ./src/graphql/queries/agenti.js